import { combineReducers } from 'redux'
import {
  reduce,
  filter,
  keyBy,
  mapValues,
  has,
  identity,
  omit,
  compose
} from 'lodash/fp'
import workbenchTypes from '@types/workbench'

/**
 * 新的菜单会排在最后，删除的菜单会被移除
 *
 * @param {Array} order 原有菜单顺序
 * @param {Array} items 最新菜单列表
 * @param {Function} selector
 * @return {Array}  最新菜单顺序
 */
const combineOrder = (order = [], items = [], selector = i => i.id) => {
  const orderMap = keyBy(identity)(order)
  const itemsMap = keyBy(selector)(items)
  const _combine = compose(
    filter(id => itemsMap[id]),
    reduce(
      (result, item) =>
        orderMap[selector(item)] ? result : [...result, selector(item)],
      order
    )
  )
  return _combine(items)
}

/**
 * @param {Object} activeMap
 * @param {Array} items
 * @param {Function} selector
 * @return {Object}
 */
const combineActive = (activeMap = {}, items = [], selector = i => i.id) => {
  const itemsMap = keyBy(selector)(items)
  let result = Object.create({})

  items.forEach(i => {
    const key = selector(i)
    result[key] = has(key)(activeMap) ? activeMap[key] : true // NOTE: 默认添加
  })

  Object.keys(activeMap).forEach(key => {
    if (!itemsMap[key]) {
      result = omit(key)(result)
    }
  })

  return result
}

function menuOrder(state = [], { type, payload }) {
  switch (type) {
    case workbenchTypes.SET_MENU_ORDER:
      const { order } = payload
      return order || state

    case workbenchTypes.RESET_MENU:
      const { menus } = payload
      return combineOrder(state, menus)
    default:
      return state
  }
}

function subMenuOrder(state = {}, { type, payload }) {
  switch (type) {
    case workbenchTypes.SET_SUB_MENU_ORDER:
      const { order } = payload
      return order || state

    case workbenchTypes.RESET_MENU:
      const { menus } = payload
      const menuMap = keyBy(i => i.id)(menus)
      return mapValues(i => combineOrder(state[i.id], i.children))(menuMap)

    default:
      return state
  }
}

function subMenuActive(state = {}, { type, payload }) {
  switch (type) {
    case workbenchTypes.SET_SUB_MENU_ACTIVE:
      return payload || state

    case workbenchTypes.RESET_MENU:
      const { menus, defaultConfig = {} } = payload

      const menuMap = keyBy(i => i.id)(menus)
      return mapValues(i => combineActive(state[i.id], i.children))(menuMap)

    default:
      return state
  }
}

export default combineReducers({
  menuOrder,
  subMenuOrder,
  subMenuActive
})
